import { MindfulnessProgramTemplateDayUnit, createMindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { createMindfulnessProgramTemplateDayUnitAudio } from './MindfulnessProgramTemplateDayUnitAudio';
import { createMindfulnessProgramTemplateDayUnitVideo } from './MindfulnessProgramTemplateDayUnitVideo';
import { createMindfulnessProgramTemplateDayUnitBreathing } from './MindfulnessProgramTemplateDayUnitBreathing';
import { createMindfulnessProgramTemplateDayUnitVideoSeries } from './MindfulnessProgramTemplateDayUnitVideoSeries';
import { createMindfulnessProgramTemplateDayUnitWorkoutTemplate } from './MindfulnessProgramTemplateDayUnitWorkoutTemplate';
import { HttpBackend } from '../../../../Services/Http/HttpBackend';

export const MindfulnessProgramTemplateDayUnitBuilder = {
  build(json: Partial<MindfulnessProgramTemplateDayUnit>): MindfulnessProgramTemplateDayUnit {
    switch (json.type) {
      case 'audio':
        return createMindfulnessProgramTemplateDayUnitAudio(json as any);
      case 'video':
        return createMindfulnessProgramTemplateDayUnitVideo(json as any);
      case 'breathing':
        return createMindfulnessProgramTemplateDayUnitBreathing(json as any);
      case 'videoSeries':
        return createMindfulnessProgramTemplateDayUnitVideoSeries(json as any);
      case 'workoutTemplate':
        return createMindfulnessProgramTemplateDayUnitWorkoutTemplate(json as any);
      default:
        return createMindfulnessProgramTemplateDayUnit(json);
    }
  },

  findOne(unitId: string): Promise<MindfulnessProgramTemplateDayUnit> {
    return HttpBackend.get(`/coach-program/mindfulness/template/unit/${unitId}`).then((res) => this.build(res));
  },
};
